<template>
  <div
    class="grid grid-cols-1 gap-4 lg:grid-cols-3"
    role="status"
    :aria-label="ariaLabel"
  >
    <section class="space-y-4 lg:col-span-1">
      <div
        class="p-5 border shadow-sm rounded-2xl bg-white/80 dark:bg-slate-900/80 border-slate-200 dark:border-slate-700 space-y-3"
      >
        <span
          class="block h-3 w-32 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
        ></span>
        <span
          class="block h-20 w-full rounded-xl bg-slate-100 dark:bg-slate-800 animate-pulse"
        ></span>
      </div>
    </section>

    <section class="space-y-4 lg:col-span-2">
      <div
        class="p-5 border shadow-sm rounded-2xl bg-white/80 dark:bg-slate-900/80 border-slate-200 dark:border-slate-700 space-y-3"
      >
        <span
          class="block h-3 w-40 rounded bg-slate-200 dark:bg-slate-700 animate-pulse"
        ></span>
        <span
          v-for="n in 3"
          :key="`body-line-${n}`"
          class="block h-12 w-full rounded-xl bg-slate-100 dark:bg-slate-800 animate-pulse"
        ></span>
      </div>
    </section>
  </div>
</template>

<script setup>
defineProps({
  ariaLabel: { type: String, default: "Loading" },
});
</script>
